function PortfolioContact() {
    return (
        <div className="clm-contact clm-fixed-hc" id="contact">
            <div className="clm-inner-container clm-container">
                <div className="clm-title">
                    <h4>CONTACT</h4>
                </div>
            </div>
        </div>
    )
}

export default PortfolioContact;